import shadows from '../shadows';

const MuiPaper = {
  styleOverrides: {
    root: {
      '&.MuiCard-root .MuiPaper-create': {
        '@media max-width(900px)': {
          boxShadow: 'none',
        },
        boxShadow: shadows[5],
      },
    },
  },
};

export default MuiPaper;
